import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  deleteSingleOfferResponse,
  exportPdf,
  getOfferResponses,
} from "../modules/actions";

const mapStateToProps = (state) => ({
  state: {
    offerResponses: state.offerResponseReducer.offerResponses,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOfferResponses,
      deleteSingleOfferResponse,
      exportPdf,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
